var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSkipAutomation = function SvgIconSkipAutomation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon-skip-automation_svg__skip"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.634 5.497c.189.105.281.325.224.533l-1.244 4.564h4.542a.469.469 0 0 1 .343.788l-6.563 7.032a.469.469 0 0 1-.794-.444l1.244-4.564H6.844a.469.469 0 0 1-.343-.788l6.563-7.032a.469.469 0 0 1 .57-.09Z",
    fill: "#fff"
  })));
};
export default SvgIconSkipAutomation;